import { useApp } from "@/store/AppStore";
import { useAuth } from "@/store/AuthStore";
import type { Role } from "@/types";

const OPTIONS: { key: Role; label: string; icon: string; short: string }[] = [
  { key: "admin", label: "Administrador (Juanka)", icon: "ri-vip-crown-2-line", short: "Admin" },
  { key: "asesor", label: "Portal Asesor", icon: "ri-user-star-line", short: "Asesor" },
];

const RoleSwitcher = ({ onSwitch }: { onSwitch?: (role: Role) => void }) => {
  const { data, setRole } = useApp();
  const { profile } = useAuth();

  // Solo el administrador puede alternar entre vista Admin y vista Asesor (previsualización).
  if (profile?.role !== "admin") {
    return (
      <span className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-secondary-500/20 text-secondary-200 border border-secondary-500/25">
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-user-star-line text-sm" />
        </span>
        Portal Asesor
      </span>
    );
  }

  const handle = (role: Role) => {
    setRole(role);
    onSwitch?.(role);
  };

  return (
    <div className="flex items-center bg-background-200/60 rounded-full p-1 border border-accent-500/20">
      {OPTIONS.map((opt) => {
        const active = data.role === opt.key;
        return (
          <button
            key={opt.key}
            onClick={() => handle(opt.key)}
            className={`flex items-center gap-1.5 px-2.5 md:px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors cursor-pointer ${
              active
                ? "bg-primary-500 text-foreground-950"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
            title={opt.label}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className={`${opt.icon} text-sm`} />
            </span>
            <span className="hidden sm:inline">{opt.short}</span>
          </button>
        );
      })}
    </div>
  );
};

export default RoleSwitcher;